import { render, staticRenderFns } from "./ThongBaoList.vue?vue&type=template&id=153c261c&scoped=true"
import script from "./ThongBaoList.vue?vue&type=script&lang=js"
export * from "./ThongBaoList.vue?vue&type=script&lang=js"
import style0 from "./ThongBaoList.vue?vue&type=style&index=0&id=153c261c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c261c",
  null
  
)

export default component.exports